import { FilledButton } from 'components';
import { HIBOU_URL } from 'constants/env';
import { FormattedMessage } from 'react-intl';
import useStyles from './DisconnectButton.styles';
import { trackEvent, GACommonEventAction, GAEventCategory} from 'services/googleAnalytics';
import {type MouseEventHandler} from 'react';

type DisconnectButtonPureProps = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const DisconnectButtonPure = ({
  onClick,
}: DisconnectButtonPureProps): JSX.Element => {
  const classes = useStyles();
  return (
    <FilledButton className={classes.button} color="violet" onClick={onClick}>
      <FormattedMessage id="button.disconnect" />
    </FilledButton>
  );
};

const DisconnectButton = (): JSX.Element => {
  const disconnect = () => {
    trackEvent(
      GAEventCategory.BUTTON,
      GACommonEventAction.CLICK,
      'Déconnexion',
    );
    window.location.href = `${HIBOU_URL}/logout`;
  };

  return <DisconnectButtonPure onClick={() => disconnect()} />;
};

export default DisconnectButton;
